import PostingStatus from "@/entities/PostingStatus";

const groupsFiltersTemplate = {
  title: "",
  postingStatus: PostingStatus.ACTIVE,
  contractors: [],
  managers: [],
  locations: [],
  projects: [],
  postings: [],
  skills: [],
};

export default groupsFiltersTemplate;